module.exports = __webpack_public_path__ + "img/20201016.743e7560.png";